import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "admin-layout" }
const _hoisted_2 = { class: "admin-main-content" }
const _hoisted_3 = { class: "admin-header" }
const _hoisted_4 = ["aria-expanded"]
const _hoisted_5 = { class: "admin-page-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdminSidebar = _resolveComponent("AdminSidebar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isSidebarOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "sidebar-overlay",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeSidebar && _ctx.closeSidebar(...args))),
          "aria-hidden": "true"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_AdminSidebar, {
      "is-open": _ctx.isSidebarOpen,
      onClose: _ctx.closeSidebar
    }, null, 8, ["is-open", "onClose"]),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "sidebar-toggle",
          "aria-label": "Toggle menu",
          "aria-expanded": _ctx.isSidebarOpen,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args)))
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("span", { class: "toggle-bar" }, null, -1),
          _createElementVNode("span", { class: "toggle-bar" }, null, -1),
          _createElementVNode("span", { class: "toggle-bar" }, null, -1)
        ]), 8, _hoisted_4),
        _createElementVNode("h2", null, _toDisplayString(_ctx.currentRouteName), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}